export const setUserDetails = (state, response) => {
    state.userData = response;
    state.userEmail = response.email;
    state.userName = response.username;
    state.userId = response.id;
    state.needsTaskRedirect = response.needsTaskRedirect;
    state.accessibility = response.accessibility;
    state.userIsManager = response.manager;
    if (!state.userData.language) {
        state.userData.language = "en";
    }
};

export const setDelegationId = (state, response) => {
    if (response && response.length) {
        state.delegationId = response[0].id;
    }
};

export const updateUserDetails = (state, response) => {
    state.userData.firstName = response.firstName;
    state.userData.lastName = response.lastName;
    state.userData.phone = response.phone;
    state.userData.language = response.language;
    state.accessibility = response.accessibility;

    if (response.newPassword) {
        state.userData.passwordLastUpdate = new Date();
    }

    state.userCookieInfo.userFirstName = response.firstName;
    state.userCookieInfo.userLastName = response.lastName;
};

export const setNotificationsSettings = (state, response) => {
    state.notificationsSettings = response;
};

export const setUserProfileDDLs = (state, response) => {
    state.userProfileDDLs = response;
};

export const setMyRoles = (state, payload) => {
    state.myRoles = payload;
};

export const setImg = (state, payload) => {
    state.userProfileImage = payload;
};

export const userCookieInfo = (state, payload) => {
    state.userCookieInfo = payload;
};

export const timestampCookie = (state, data) => {
    state.timestampCookie = data;
};

export const setUserListDelegation = (state) => state.userListDelegation;
